/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampTripLocationShowResponse } from '../../models/camp-trip-location-show-response';

export interface DeleteCampTripLocationRemove$Params {
  id: string;
}

export function deleteCampTripLocationRemove(http: HttpClient, rootUrl: string, params: DeleteCampTripLocationRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<CampTripLocationShowResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteCampTripLocationRemove.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampTripLocationShowResponse>;
    })
  );
}

deleteCampTripLocationRemove.PATH = '/v1/camp-trip-location/{id}';
